

import action from './action';
import { RQ, getStatus } from 'utils';
import { dateFormat } from 'utils/filters';
import Icon from 'vux/src/components/icon/index.vue'

import { NavBar, yoButton, NullData } from 'components';
import List from 'components/list/index';
import { throttle } from 'lodash';
import Clocker from 'components/Clocker';
import {
Tag,
Row,
Col,
Cell,
CellGroup,
Swipe,
SwipeItem,
GoodsAction,
GoodsActionBigBtn,
GoodsActionMiniBtn,
Tab,
Tabs,
Rate,
Popup,
Sku,
Actionsheet,
Button,
Stepper,
NoticeBar,
PullRefresh

} from 'vant';
import isNil from 'lodash/isNil';

export default {
name: 'page',
props: ['params'],
metaInfo() {
return {
title: this.pageTitle
};
},
components: {
Icon,
yoButton,
Tag,
Row,
'van-cell': Cell,
'van-col': Col,
'van-actionsheet': Actionsheet,
'van-button': Button,
'van-popup': Popup,
'van-sku': Sku,
'van-pull-refresh': PullRefresh,
Cell,
CellGroup,
Swipe,
SwipeItem,
GoodsAction,
GoodsActionBigBtn,
GoodsActionMiniBtn,
Tab,
Tabs,
Rate,
'ylp-list': List,
NullData,
Stepper,
'van-notice-bar': NoticeBar,
Clocker
},
created() {
this.getTipInfo();
this.getInfo();
this.getMemberInfo();
this.getGoodsComments(1);
this.addShare(this.params.goodsId, this.query.inviteCode);
},
mounted() {
this.scrollEl = this.$el.querySelector('.goods');
this.throttleOnInfiniteScroll = throttle(this.onInfiniteScroll, 400);
this.scrollEl.addEventListener('scroll', this.handleScroll);
},
data() {
return {
pageTitle: '商品详情',
showCoupons: false,
showParams: false,//产品参数
showSale: false,//促销参数
showChooseSpec: false,
showMn: false,
isopen: false,//是否开通会员
showLogin: false,
showActivity: false,
activeTab: 0,
goods: {},
commentsTags: {},
MemberInfo: {},
comments: {
items: [],
page: 0,
loading: false
},
enterpriseNo: G.member.enterpriseNo || this.params.enterprise || this.params.enterpriseNo,
showCustomAction: false, //是否显示sku,
buyNum: 1,
skuGoods: {

title: '测试商品',

picture: 'https://img.yzcdn.cn/2.jpg'
},
popContent: '需要登录注册后才能购买',
goodsId: '1',
quotaUsed: 0,
state: {},
tag: undefined,
showOpenVip: true,
loading: false,
finished: false,
startTime: '2018-07-11 23:59:00',
endTime: '2018-07-14 13:59:00',

activity: {},
activityStatus: '',  //活动状态
clockerFmt: {}, // 限时抢购倒计时
tipInfo: {
openType: 1
}
};
},
computed: {
activityGoodsIamge() {
const { activity, activityStatus, goods } = this;
let activityImages = goods && goods.goodsImgs ? goods.goodsImgs : [];
if (activity && activity.activityImg && activityStatus != 'DONE') {
activityImages = [activity.activityImg, ...activityImages];
}
return activityImages;
},
rolePrice() {
const { whichRole, realPrice, leadPrice } = this.goods;
return whichRole == 1 ? realPrice : leadPrice;
},
whichRolePrice() {
const { whichRole, realPrice, leadPrice } = this.goods;
return whichRole !== 1 ? '实体价: ￥' + realPrice : '会员价: ￥' + leadPrice;
},
goodsSpecs() {
return this.state.goodsSpecs || [];
},
goodsHeader() {
const { goodsInfo, selectedGoodsInfo, buyNum, goodsSpecs, visible } = this.state;
const { whichRole, realPrice, leadPrice, goodsImgs, specialPrice, activity } = this.goods || {};
const activityStatus = this.activityStatus;
const goodsImg = goodsImgs && goodsImgs.length > 0 ? goodsImgs[0].artworkImage : null;
const {
goodsInfoStock,
goodsInfoImg,
realPrice: infoRealPrice,
leadPrice: infoLeadPrice,
specialPrice: infoSpecialPrice,
goodsAdded
} = selectedGoodsInfo || {};
const goodsHeaderImg = selectedGoodsInfo ? goodsInfoImg : goodsImg;
const rolePrice = specialPrice != null && specialPrice != undefined ? specialPrice : whichRole == 1 ? realPrice : leadPrice;
const infoRolePrice = infoSpecialPrice != null && infoSpecialPrice != undefined ? infoSpecialPrice : whichRole == 1 ? infoRealPrice : infoLeadPrice;
const price = activityStatus == 'ING' ? activity.price : selectedGoodsInfo ? infoRolePrice : rolePrice;

const alertText = selectedGoodsInfo ?
`已选： ${Object.values(this.getSelectedSpec(goodsSpecs)).map(v => v.specDetailValue).join(' ')} ${buyNum}件`
: '请选择';
return {
image: goodsHeaderImg,
price: price,
alertText: alertText
};
},
noStock() {
const { selectedGoodsInfo } = this.state;
const { goodsInfoStock } = selectedGoodsInfo || {};
return goodsInfoStock <= 0 || this.goods.goodsStock <= 0;
},
xiajia() {
const { selectedGoodsInfo } = this.state;
const { goodsAdded } = selectedGoodsInfo || {};
return goodsAdded == 0 || this.goods.goodsAdded == 0;
},
goodsActivity() {
const { thirdPrice } = this.goods || {};
const { hours, minutes, seconds } = this.clockerFmt || {};
const { price, priceName, surplusStock } = this.activity || {};
const activityStatus = this.activityStatus;
let tip,
leftBgColor,
rightBgColor,
priceNameColor,
color,
timeTipColor,
timeColor;
switch (activityStatus) {
case 'WILL': {
return {
tip: '距开始还剩',
hours,
minutes,
seconds,
price,
priceName,
leftViewStyle: 'background-color: #ff5775; color: #fff',
priceNameStyle: 'background-color: #fff; color: #ff5775',
rightViewStyle: 'background-color: #f1fc8f; color: #b22f40',
timeBoxStyle: 'background-color: #b22f40; color: #fff',
tipStyle: 'color: #b22f40',
oldPrice: `${thirdPrice.priceName}${thirdPrice.price}`,
oldPriceStyle: thirdPrice.underlineFlag
? 'text-decoration: line-through'
: ''
};
}
case 'ING': {
return {
tip: '距结束还剩',
hours,
minutes,
seconds,
price,
priceName,
leftViewStyle: 'background-color: #ff5775; color: #fff',
priceNameStyle: 'background-color: #fff; color: #ff5775',
rightViewStyle: 'background-color: #ff7991; color: #fff',
timeBoxStyle: 'background-color: #b22f40; color: #fff',
tipStyle: 'color: #fff',
oldPrice: `${thirdPrice.priceName}${thirdPrice.price}`,
oldPriceStyle: thirdPrice.underlineFlag
? 'text-decoration: line-through'
: '',
soldOut:
surplusStock !== undefined &&
surplusStock !== null &&
surplusStock <= 0
};
}
case 'NEXT': {
return {
tip: '距离下一场开始',
hours,
minutes,
seconds,
price,
priceName,
leftViewStyle: 'background-color: #ff5775; color: #fff',
priceNameStyle: 'color: #ff5775',
rightViewStyle: 'background-color: #ff7991; color: #ff5775',
tipStyle: 'color: #fff',
oldPrice: `${thirdPrice.priceName}${thirdPrice.price}`,
oldPriceStyle: thirdPrice.underlineFlag
? 'text-decoration: line-through'
: '',
soldOut:
surplusStock !== undefined &&
surplusStock !== null &&
surplusStock <= 0
};
}
case 'DONE': {
return null;
}
default: {
return null;
}
}
},
activityLabels() {
const activityLabel = this.goods.activityLabel;


if (activityLabel && activityLabel.length > 0) {
return activityLabel.map(item => {
return {
...item,
style: `background-color: ${item.labelBGColor || '#ff5775'}; color: ${item.labelColor || '#fff'}; border-color: ${item.labelBorderColor || 'transparent'}`
};
});
} else {
return null;
}
},
infoData() {
let { activity, goodsLabel, activityStatus, firstPrice = {}, secondPrice = {}, thirdPrice = {}, taxFee, goodsType, salesSum, expressPrice, goodsName, warehouse, memberType } = this.goods || {};
console.log('---------this.goods', this.goods, this.state);
let isActivity = !isNil(activity);
activity = isNil(activity) ? {} : activity;
secondPrice = isNil(secondPrice) ? {} : secondPrice;
return {
goodsName, goodsType, isActivity, activityStatus,
firstPrice: !isNil(firstPrice.price) ? (/￥/).exec(firstPrice.price) != null ? `${firstPrice.price}` : `￥${firstPrice.price}` : '',
firstPriceName: firstPrice.memberFlag ? firstPrice.memberName : '',
firstStyle: `background-color: ${firstPrice.memberBgColor}; color: ${firstPrice.memberColor}; text-decoration: ${firstPrice.underlineFlag ? 'line-through' : 'none'}`,
secondPrice: secondPrice.price,
secondPriceName: memberType == 1 ? secondPrice.memberFlag ? secondPrice.memberName : '' : secondPrice.priceName,
secondStyle: `background-color: ${secondPrice.memberBgColor}; color: ${secondPrice.memberColor}; text-decoration: ${secondPrice.underlineFlag ? 'line-through' : 'none'}`,
thirdPrice: thirdPrice.price,
thirdPriceName: thirdPrice.priceName,
activityPrice: isActivity ? activity.price : '',
activityPriceName: isActivity ? activity.priceName : '',
hasLine: thirdPrice.underlineFlag,
salesSum: `销量：${salesSum}`,
expressPrice: `运费：${expressPrice}`,
taxFee: `税费：${taxFee}`,
memberType: memberType || 1


};
},
cornorLabel() {
let goodsLabel = this.goods.goodsLabel || [];






if (goodsLabel && goodsLabel.length > 0) {
return goodsLabel.map(item => {
return {
...item,
style: `background-color: ${item.labelBGColor || '#ff5775'}; color: ${item.labelColor || '#fff'}; border-color: ${item.labelBorderColor || 'transparent'}`
};
});
} else {
return null;
}
}
},
filters: {
dateFormat
},
methods: {
...action
},







beforeRouteUpdate(to, from, next) {
console.log('goods beforeRouteUpdate');
if (to.params.goodsId) {
action.addShare(to.params.goodsId, to.query.inviteCode);
}
next();
}
};



// WEBPACK FOOTER //
// ./src/module/goods/detail/page.vue